<form [formGroup]="smsForm" name="smsForm">
  <glxy-form-field [required]="true">
    <glxy-label>Template Name</glxy-label>
    <input type="text" required placeholder="My SMS template" matInput formControlName="name" />
  </glxy-form-field>
  <ng-container *ngIf="!allowDynamic; else hasDynamic">
    <glxy-form-field [required]="true">
      <glxy-label>Message</glxy-label>
      <textarea matInput required formControlName="message" placeholder="Hello!"></textarea>
    </glxy-form-field>
  </ng-container>
  <ng-template #hasDynamic>
    <glxy-form-field [required]="true">
      <glxy-label>
        <span class="text-actions">
          <div>Message</div>
          <templates-dynamic-component-selector [target]="smsText" (modelChange)="emitNewTemplateValue($event)">
          </templates-dynamic-component-selector>
        </span>
      </glxy-label>
      <textarea #smsText matInput required formControlName="message" placeholder="Hello!"></textarea>
      <glxy-hint
        *ngIf="textLimit > 0"
        align="end"
        [ngStyle]="{
          color: smsForm?.controls?.message?.errors?.textTooLong ? 'red' : null
        }"
      >
        {{ calculatedTextLength$$ | async }}/{{ textLimit }}
      </glxy-hint>
    </glxy-form-field>
  </ng-template>
</form>
